import { useQuery } from 'react-query'; 
import axiosInstance from './axiosInstance';

const fetchInActiveModules = async () => {
  const response = await axiosInstance.get('/super-admin/inactive-module');
  return response.data;
};

export const useGetInActiveModules = () => {
  return useQuery('inActiveModules', fetchInActiveModules); 
};
